import React, { useState, useRef, useEffect } from 'react';
import ButtonIconSimple from '../ButtonIconSimple';
import AlertIcon from '../../../../icons/AlertIcon';

const ButtonIconSimpleDoubleConfirmation = ({
	children,
	warningChildren,
	onConfirm,
	confirmTimeout = 2000,
	disabled = false,
	additionalClasses = [],
	size = 'md',
	ariaLabel = 'Delete',
	ariaLabelWarning = 'Click again to confirm'
}) => {
	const [isWarningState, setIsWarningState] = useState(false);
	const timerRef = useRef(null);

	// Cleanup timer on unmount
	useEffect(() => {
		return () => {
			if (timerRef.current) {
				clearTimeout(timerRef.current);
			}
		};
	}, []);

	const handleClick = () => {
		if (disabled) return;

		if (!isWarningState) {
			// First click - enter warning state
			setIsWarningState(true);
			timerRef.current = setTimeout(() => {
				setIsWarningState(false);
			}, confirmTimeout);
		} else {
			// Second click - execute confirmation
			if (timerRef.current) {
				clearTimeout(timerRef.current);
			}
			setIsWarningState(false);
			if (onConfirm) {
				onConfirm();
			}
		}
	};

	const classes = isWarningState ? [...additionalClasses, 'appBtnIconSimple--warning'] : additionalClasses;
	const currentAriaLabel = isWarningState ? ariaLabelWarning : ariaLabel;

	return (
		<div aria-label={currentAriaLabel} title={currentAriaLabel}>
			<ButtonIconSimple
				onClick={handleClick}
				disabled={disabled}
				additionalClasses={classes}
				size={size}>
				{isWarningState ? (warningChildren || <AlertIcon />) : children}
			</ButtonIconSimple>
		</div>
	);
};

export default ButtonIconSimpleDoubleConfirmation;
